<template>
  <div class="page income-page">
    <div class="top income-top">
      <div class="date-filter">
        <div class="date-row">
          <span class="date-label">收入时间</span>
          <span class="date-value" @click="openDateRangePicker">{{ filters.incomeStartDate || "开始日期" }}</span>
          <span class="date-sep">-</span>
          <span class="date-value" @click="openDateRangePicker">{{ filters.incomeEndDate || "结束日期" }}</span>
          <span v-if="filters.incomeStartDate || filters.incomeEndDate" class="date-clear" @click="clearRange">清空</span>
        </div>
        <div class="date-row">
          <span class="date-label">中心</span>
          <span class="date-value date-value--wide" @click="openTopDepartmentPicker('filter')">{{ filterTopDepartmentLabel || "全部中心" }}</span>
          <span v-if="filters.topDepartmentId !== null && filters.topDepartmentId !== undefined && filters.topDepartmentId !== ''" class="date-clear" @click="clearTopDepartmentFilter">清空</span>
        </div>
      </div>
      <div class="income-summary-bar">
        <span class="income-summary-item">
          合计金额
          <strong class="income-summary-amount">{{ formatAmountDisplay(summary.totalAmount) }}</strong>
        </span>
        <span class="income-summary-item">
          流水条数
          <strong class="income-summary-count">{{ summary.totalCount }}</strong>
        </span>
      </div>
      <div class="income-type-tabs">
        <van-tabs v-model="typeTab" swipeable @change="onTypeTabChange">
          <van-tab v-for="tab in typeTabs" :key="tab.value" :title="tab.label" :name="tab.value" />
        </van-tabs>
      </div>
    </div>

    <div class="list income-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="records-wrap">
            <van-empty v-if="!items.length && !loading" description="暂无数据" class="empty" />
            <div
              v-for="row in items"
              :key="row.id"
              :class="[
                'card',
                'booking-card',
                'income-booking-card',
                incomeTypeClass(row),
                { 'income-booking-card--confirmed': isIncomeConfirmed(row) }
              ]"
            >
              <div class="booking-card-top">
                <div class="booking-student">
                  <span class="booking-student-name">{{ getIncomeTypeLabel(row.type, row.typeName) }}</span>
                  <van-tag v-if="isIncomeConfirmed(row)" class="income-status-tag income-status-tag--confirmed">已确认</van-tag>
                </div>
                <span class="income-amount">{{ formatAmountDisplay(row.amount) }}</span>
              </div>
              <div class="booking-parent">
                <span class="booking-parent-label">关联学员：</span>
                <span>{{ row.studentName || "-" }}</span>
              </div>
              <div v-if="isMiscIncomeRow(row)" class="booking-remark">杂费类型：{{ getFeeTypeDisplay(row) }}</div>
              <div v-if="row.staffName || row.performanceStaffName" class="booking-remark">
                业绩归属人：{{ (row.staffName || row.performanceStaffName || "").trim() || "-" }}
              </div>
              <div v-if="row.performanceAmount !== null && row.performanceAmount !== undefined && row.performanceAmount !== ''" class="booking-remark">
                业绩金额：{{ formatAmountDisplay(row.performanceAmount) }}
              </div>
              <div class="booking-remark">支付方式：{{ formatPaymentMethodDisplay(row) }}</div>
              <div class="booking-remark">所属中心：{{ row.topDepartmentName || row.topDepartmentId || "-" }}</div>
              <div class="booking-remark">收入时间：{{ row.incomeTime || "-" }}</div>
              <div class="booking-remark">创建时间：{{ row.createTime || "-" }}</div>
              <template v-if="isIncomeConfirmed(row)">
                <div class="booking-remark">确认人：{{ row.confirmPeopleName || "-" }}</div>
                <div class="booking-remark">确认时间：{{ row.confirmTime || "-" }}</div>
              </template>
              <div class="booking-remark">备注：{{ row.remark || "-" }}</div>
              <div v-if="!isIncomeConfirmed(row)" class="income-actions">
                <van-button plain hairline round size="small" class="income-op-btn income-op-btn--edit" @click="openEdit(row)">编辑</van-button>
                <van-button plain hairline round size="small" class="income-op-btn income-op-btn--delete" @click="onDelete(row)">删除</van-button>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-popup v-model="formPopup.show" position="bottom" round :style="{ height: '72vh' }">
      <div class="booking-popup-wrap popup-wrap">
        <div class="popup-head">
          <div class="popup-title">{{ formPopup.mode === "create" ? "新增收入" : "编辑收入" }}</div>
          <van-icon name="cross" class="popup-close" @click="formPopup.show = false" />
        </div>
        <div class="booking-popup-scroll popup-body">
          <van-field v-model.trim="formPopup.form.amount" label="金额" placeholder="请输入金额" type="number" required />
          <van-field
            readonly
            clickable
            label="支付方式"
            :value="formPaymentMethodLabel"
            placeholder="请选择支付方式"
            required
            @click="openPaymentMethodPicker"
          />
          <van-field
            v-if="formPopup.mode === 'create'"
            readonly
            class="field-locked"
            label="收入类型"
            value="杂费"
            required
          >
            <template #right-icon>
              <van-icon name="lock" class="field-lock-icon" />
            </template>
          </van-field>
          <van-field
            v-else
            readonly
            class="field-locked"
            label="收入类型"
            :value="formTypeLabel"
            required
          >
            <template #right-icon>
              <van-icon name="lock" class="field-lock-icon" />
            </template>
          </van-field>
          <van-field
            v-if="showFormOtherFeeType"
            readonly
            clickable
            label="杂费类型"
            :value="formOtherFeeTypeLabel"
            placeholder="请选择杂费类型"
            required
            @click="openOtherFeeTypePicker"
          />
          <van-field
            v-if="showFormOtherFeeType"
            readonly
            clickable
            label="业绩归属人"
            :value="formPerformanceStaffLabel"
            placeholder="请选择业绩归属人（选填）"
            @click="openPerformanceStaffPicker"
          >
            <template v-if="formPopup.form.performanceStaffId" #button>
              <span class="field-clear-btn" @click.stop="clearPerformanceStaff">清除</span>
            </template>
          </van-field>
          <van-field
            v-if="showFormOtherFeeType"
            v-model.trim="formPopup.form.performanceAmount"
            label="业绩金额"
            placeholder="请输入业绩金额（选填）"
            type="number"
          />
          <van-field
            readonly
            clickable
            label="关联学员"
            :value="formStudentLabel"
            :placeholder="studentFieldPlaceholder"
            :required="!isStudentOptional"
            @click="openStudentPicker"
          >
            <template v-if="formPopup.form.studentId" #button>
              <span class="field-clear-btn" @click.stop="clearFormStudent">清除</span>
            </template>
          </van-field>
          <van-field
            readonly
            clickable
            label="所属中心"
            :value="formTopDepartmentLabel"
            placeholder="请选择所属中心"
            required
            @click="openTopDepartmentPicker('form')"
          />
          <van-field
            readonly
            clickable
            label="收入时间"
            :value="formPopup.form.incomeTime"
            placeholder="请选择收入时间"
            required
            @click="openFormTimePicker"
          />
          <van-field v-model.trim="formPopup.form.remark" label="备注" type="textarea" rows="2" autosize placeholder="选填" />
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="formPopup.submitting" @click="submitForm">保存</van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="studentPicker.show" position="bottom" round :style="{ height: '70vh' }">
      <div class="student-picker-inner">
        <div class="popup-head">
          <div class="popup-title">选择关联学员</div>
          <van-icon name="cross" class="popup-close" @click="closeStudentPicker" />
        </div>
        <van-search
          v-model="studentPicker.keyword"
          placeholder="搜索学员姓名/家长/手机号"
          shape="round"
          @search="onStudentSearch"
          @input="onStudentKeywordInput"
        />
        <div class="student-list-wrap">
          <van-list
            v-model="studentPicker.loading"
            :finished="studentPicker.finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onStudentPickerLoad"
          >
            <van-empty v-if="!studentPicker.loading && studentPicker.list.length === 0" description="暂无学员" class="panel-empty" />
            <div
              v-for="stu in studentPicker.list"
              :key="stu.studentId"
              :class="['student-item', { active: String(formPopup.form.studentId) === String(stu.studentId) }]"
              @click="selectStudent(stu)"
            >
              <div class="student-item-name">{{ stu.stuName || "-" }}</div>
              <div class="student-item-sub">{{ stu.name || "-" }} {{ stu.mobile || "" }}</div>
            </div>
          </van-list>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="picker.show" position="bottom">
      <van-picker show-toolbar :title="picker.title" :columns="picker.columns" @confirm="onPickerConfirm" @cancel="picker.show = false" />
    </van-popup>

    <van-popup v-model="formTimePicker.show" position="bottom">
      <van-datetime-picker
        type="datetime"
        title="选择收入时间"
        :value="formTimePicker.value"
        @confirm="onFormTimeConfirm"
        @cancel="formTimePicker.show = false"
      />
    </van-popup>

    <van-calendar
      v-model="dateRangePickerShow"
      type="range"
      :min-date="dateRangePickerMinDate"
      :max-date="dateRangePickerMaxDate"
      :allow-same-day="true"
      :show-confirm="true"
      :default-date="dateRangePickerDefault"
      :z-index="5000"
      color="rgb(242, 124, 52)"
      @close="dateRangePickerShow = false"
      @confirm="onConfirmDateRange"
    />

    <div class="bottom-bar">
      <van-button type="primary" block round class="theme-btn" @click="openCreate">新增收入</van-button>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import { fetchTopDepartments, fetchCustomerList, fetchStaffList } from "@/api/customer"
import { ensureCurrentStaffProfile, getCurrentTopDepartmentId } from "@/store/currentStaff"
import { resetPageScrollAfterPaint } from "@/utils/scroll"
import {
  fetchIncomeDetailList,
  fetchIncomeDetailSummary,
  createIncomeDetail,
  updateIncomeDetail,
  deleteIncomeDetail
} from "@/api/income"

const INCOME_TYPE_MISC = 5

const INCOME_TYPE_OPTIONS = [
  { text: "定金", value: 0 },
  { text: "首单", value: 1 },
  { text: "UP", value: 2 },
  { text: "REN", value: 3 },
  { text: "英皇课", value: 4 },
  { text: "杂费", value: INCOME_TYPE_MISC },
  { text: "其他", value: 6 }
]

/** 与学员管理续费杂费弹窗一致 */
const OTHER_FEE_TYPE_OPTIONS = [
  { text: "考级费用", value: 1 },
  { text: "比赛费用", value: 2 },
  { text: "琴房使用", value: 3 },
  { text: "钢琴搬运", value: 4 },
  { text: "音乐会门票", value: 5 },
  { text: "节拍器/书本费", value: 6 },
  { text: "乐器售卖", value: 7 },
  { text: "试听费用", value: 9 },
  { text: "其他杂费", value: 8 },
]

const PAYMENT_METHOD_OPTIONS = [
  { text: "刷卡(用POS机)", value: 1 },
  { text: "支付宝-校方主扫码", value: 2 },
  { text: "支付宝-校方被扫", value: 3 },
  { text: "微信-校方主扫码", value: 4 },
  { text: "微信-校方被扫", value: 5 },
  { text: "转账(转公司公账)", value: 6 },
  { text: "大众点评", value: 7 },
  { text: "扫后台码付款", value: 8 },
  { text: "现金(微信或支付宝收款)", value: 9 }
]

function formatDateTime(date) {
  const dt = date instanceof Date ? date : new Date(date)
  const y = dt.getFullYear()
  const m = String(dt.getMonth() + 1).padStart(2, "0")
  const d = String(dt.getDate()).padStart(2, "0")
  const h = String(dt.getHours()).padStart(2, "0")
  const mm = String(dt.getMinutes()).padStart(2, "0")
  const s = String(dt.getSeconds()).padStart(2, "0")
  return `${y}-${m}-${d} ${h}:${mm}:${s}`
}

function formatDateOnly(date) {
  const dt = date instanceof Date ? date : new Date(date)
  const y = dt.getFullYear()
  const m = String(dt.getMonth() + 1).padStart(2, "0")
  const d = String(dt.getDate()).padStart(2, "0")
  return `${y}-${m}-${d}`
}

function getDefaultIncomeDateRange() {
  const now = new Date()
  const first = new Date(now.getFullYear(), now.getMonth(), 1)
  return {
    incomeStartDate: formatDateOnly(first),
    incomeEndDate: formatDateOnly(now)
  }
}

export default {
  name: "IncomeManage",
  data() {
    return {
      loading: false,
      refreshing: false,
      finished: false,
      page: 1,
      pageSize: 20,
      items: [],
      summary: {
        totalAmount: 0,
        totalCount: 0
      },
      scrollToTopAfterLoad: false,
      typeTab: "all",
      typeTabs: [{ label: "全部", value: "all" }].concat(
        INCOME_TYPE_OPTIONS.map(x => ({ label: x.text, value: String(x.value) }))
      ),
      filters: {
        type: null,
        topDepartmentId: null,
        ...getDefaultIncomeDateRange()
      },
      staffOptions: [],
      dateRangePickerShow: false,
      dateRangePickerMinDate: new Date(1970, 0, 1),
      dateRangePickerMaxDate: new Date(2100, 11, 31),
      topDepartmentOptions: [],
      formPopup: {
        show: false,
        mode: "create",
        submitting: false,
        form: {
          id: null,
          amount: "",
          type: null,
          typeName: "",
          feeType: null,
          performanceStaffId: null,
          performanceStaffName: "",
          performanceAmount: "",
          studentId: null,
          studentName: "",
          topDepartmentId: null,
          incomeTime: "",
          paymentMethod: null,
          remark: ""
        }
      },
      studentPicker: {
        show: false,
        loading: false,
        requesting: false,
        finished: false,
        page: 1,
        pageSize: 20,
        keyword: "",
        keywordTimer: null,
        list: []
      },
      picker: {
        show: false,
        title: "",
        type: "",
        columns: []
      },
      formTimePicker: {
        show: false,
        value: new Date()
      }
    }
  },
  computed: {
    dateRangePickerDefault() {
      const start = this.filters.incomeStartDate
      const end = this.filters.incomeEndDate
      if (!start || !end) {
        const today = new Date()
        const tomorrow = new Date()
        tomorrow.setDate(today.getDate() + 1)
        return [today, tomorrow]
      }
      return [new Date(start.replace(/-/g, "/")), new Date(end.replace(/-/g, "/"))]
    },
    formTypeLabel() {
      return this.getIncomeTypeLabel(this.formPopup.form.type, this.formPopup.form.typeName) || ""
    },
    formIncomeTypeNum() {
      return this.resolveIncomeType(this.formPopup.form.type, this.formPopup.form.typeName)
    },
    showFormOtherFeeType() {
      if (this.formPopup.mode === "create") return true
      return this.formIncomeTypeNum === INCOME_TYPE_MISC
    },
    formOtherFeeTypeLabel() {
      return this.getFeeTypeLabel(this.formPopup.form.feeType)
    },
    formPerformanceStaffLabel() {
      const name = (this.formPopup.form.performanceStaffName || "").trim()
      if (name) return name
      const hit = this.staffOptions.find(x => String(x.value) === String(this.formPopup.form.performanceStaffId))
      return hit ? hit.text : ""
    },
    formStudentLabel() {
      return (this.formPopup.form.studentName || "").trim()
    },
    formTopDepartmentLabel() {
      const hit = this.topDepartmentOptions.find(x => String(x.value) === String(this.formPopup.form.topDepartmentId))
      return hit ? hit.text : ""
    },
    formPaymentMethodLabel() {
      return this.getPaymentMethodLabel(this.formPopup.form.paymentMethod)
    },
    filterTopDepartmentLabel() {
      const hit = this.topDepartmentOptions.find(x => String(x.value) === String(this.filters.topDepartmentId))
      return hit ? hit.text : ""
    },
    isStudentOptional() {
      const t = Number(this.formPopup.form.type)
      return t === 5 || t === 6
    },
    studentFieldPlaceholder() {
      return this.isStudentOptional ? "选填" : "必填"
    },
    // no-op
  },
  created() {
    this.loadTopDepartments()
    this.loadStaffOptions()
    this.onRefresh()
  },
  methods: {
    formatAmountDisplay(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return "-"
      return `￥${n}`
    },
    isIncomeConfirmTrue(v) {
      return v === true || v === 1 || v === "1" || v === "true"
    },
    isIncomeConfirmed(row) {
      if (!row) return false
      const fields = [row.isIncomeConfirm, row.incomeConfirm, row.isConfirm, row.confirmStatus]
      for (const v of fields) {
        if (v === 0 || v === "0" || v === false || v === "false") continue
        if (this.isIncomeConfirmTrue(v)) return true
      }
      if ((row.confirmTime || "").trim()) return true
      return false
    },
    getIncomeTypeLabel(type, fallback) {
      const n = this.resolveIncomeType(type, fallback)
      if (n === null) return ""
      const hit = INCOME_TYPE_OPTIONS.find(x => Number(x.value) === n)
      return hit ? hit.text : (typeof fallback === "string" ? fallback : "")
    },
    resolveIncomeType(type, typeName) {
      if (type !== null && type !== undefined && type !== "") {
        const n = Number(type)
        if (Number.isFinite(n) && n >= 0 && n <= 6) return n
      }
      const name = (typeName || "").trim()
      if (name) {
        const hit = INCOME_TYPE_OPTIONS.find(x => x.text === name)
        if (hit) return hit.value
      }
      return null
    },
    isMiscIncomeRow(row) {
      return this.resolveIncomeType(row?.type, row?.typeName) === INCOME_TYPE_MISC
    },
    pickFeeType(row) {
      const raw = row?.feeType
      if (raw === null || raw === undefined || raw === "") return null
      const n = Number(raw)
      return Number.isFinite(n) ? n : null
    },
    getFeeTypeLabel(value) {
      if (value === null || value === undefined || value === "") return ""
      const hit = OTHER_FEE_TYPE_OPTIONS.find(x => Number(x.value) === Number(value))
      return hit ? hit.text : ""
    },
    getFeeTypeDisplay(row) {
      const name = (row?.feeTypeName || "").trim()
      if (name) return name
      const label = this.getFeeTypeLabel(this.pickFeeType(row))
      return label || "-"
    },
    getPaymentMethodLabel(value, fallbackName) {
      const name = (fallbackName || "").trim()
      if (name) return name
      if (value === null || value === undefined || value === "") return ""
      const hit = PAYMENT_METHOD_OPTIONS.find(x => Number(x.value) === Number(value))
      return hit ? hit.text : String(value)
    },
    formatPaymentMethodDisplay(row) {
      if (!row || typeof row !== "object") return "-"
      const name = (row.paymentMethodName || "").trim()
      return name || "-"
    },
    resolvePaymentMethodValue(value) {
      if (value === null || value === undefined || value === "") return null
      const n = Number(value)
      return Number.isFinite(n) ? n : null
    },
    async openStudentPicker() {
      this.studentPicker.keyword = ""
      this.studentPicker.list = []
      this.studentPicker.page = 1
      this.studentPicker.finished = false
      this.studentPicker.show = true
      await this.searchStudents(false)
    },
    closeStudentPicker() {
      this.studentPicker.keyword = ""
      this.studentPicker.show = false
    },
    onStudentKeywordInput() {
      if (this.studentPicker.keywordTimer) clearTimeout(this.studentPicker.keywordTimer)
      this.studentPicker.keywordTimer = setTimeout(() => {
        this.searchStudents(true)
      }, 350)
    },
    onStudentSearch() {
      this.searchStudents(true)
    },
    onStudentPickerLoad() {
      this.searchStudents(false)
    },
    async searchStudents(reset = false) {
      if (reset) {
        this.studentPicker.page = 1
        this.studentPicker.finished = false
        this.studentPicker.list = []
      }
      if (this.studentPicker.requesting || this.studentPicker.finished) {
        this.studentPicker.loading = false
        return
      }
      this.studentPicker.loading = true
      this.studentPicker.requesting = true
      try {
        const keyword = (this.studentPicker.keyword || "").trim()
        const res = await fetchCustomerList({
          displayStart: this.studentPicker.page,
          displayLength: this.studentPicker.pageSize,
          allName: keyword || undefined,
          statusList: [0, 1, 2, 3, 4]
        })
        const list = Array.isArray(res?.data) ? res.data : []
        const mapped = list
          .map(it => {
            const studentId = it.studentId
            if (studentId === null || studentId === undefined || studentId === "") return null
            return {
              studentId,
              stuName: it.stuName || it.studentName || "-",
              name: it.name || "-",
              mobile: it.mobile || ""
            }
          })
          .filter(Boolean)
        this.studentPicker.list = this.studentPicker.list.concat(mapped)
        this.studentPicker.finished = mapped.length < this.studentPicker.pageSize
        if (!this.studentPicker.finished) this.studentPicker.page += 1
      } catch (e) {
        if (reset) this.studentPicker.list = []
      } finally {
        this.studentPicker.requesting = false
        this.studentPicker.loading = false
      }
    },
    selectStudent(stu) {
      if (!stu) return
      this.formPopup.form.studentId = stu.studentId
      this.formPopup.form.studentName = (stu.stuName || "").trim() || "-"
      this.studentPicker.show = false
    },
    clearFormStudent() {
      this.formPopup.form.studentId = null
      this.formPopup.form.studentName = ""
    },
    incomeTypeClass(row) {
      const t = Number(row?.type)
      if (t === 0) return "income-type-0"
      if (t === 1) return "income-type-1"
      if (t === 2) return "income-type-2"
      if (t === 3) return "income-type-3"
      if (t === 4) return "income-type-4"
      if (t === 5) return "income-type-5"
      if (t === 6) return "income-type-6"
      return "income-type-default"
    },
    buildFilterPayload() {
      return {
        type: this.filters.type === null || this.filters.type === undefined ? undefined : Number(this.filters.type),
        topDepartmentId:
          this.filters.topDepartmentId === null || this.filters.topDepartmentId === undefined || this.filters.topDepartmentId === ""
            ? undefined
            : Number(this.filters.topDepartmentId),
        incomeStartTime: this.filters.incomeStartDate || undefined,
        incomeEndTime: this.filters.incomeEndDate || undefined
      }
    },
    buildSearchPayload() {
      return {
        ...this.buildFilterPayload(),
        displayStart: this.page,
        displayLength: this.pageSize
      }
    },
    resolveSummary(res) {
      const raw =
        res && typeof res === "object" && res.data !== undefined && !Array.isArray(res.data) ? res.data : res
      return {
        totalAmount: Number(raw?.totalAmount) || 0,
        totalCount: Number(raw?.totalCount) || 0
      }
    },
    async loadSummary() {
      try {
        const res = await fetchIncomeDetailSummary(this.buildFilterPayload())
        this.summary = this.resolveSummary(res)
      } catch (e) {
        this.summary = { totalAmount: 0, totalCount: 0 }
      }
    },
    async loadTopDepartments() {
      try {
        const res = await fetchTopDepartments()
        const list = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : [])
        this.topDepartmentOptions = list
          .map(item => ({ text: item.weName || item.name || "-", value: item.weId ?? item.id }))
          .filter(x => x.value !== null && x.value !== undefined && x.value !== "")
      } catch (e) {
        this.topDepartmentOptions = []
      }
    },
    async loadStaffOptions() {
      try {
        const res = await fetchStaffList({ displayStart: 1, displayLength: 500 })
        const list = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : (Array.isArray(res?.list) ? res.list : []))
        this.staffOptions = list
          .map(item => ({
            text: item.weName || item.name || item.staffName || "-",
            value: item.id ?? item.weId ?? item.staffId
          }))
          .filter(x => x.value !== null && x.value !== undefined && x.value !== "")
      } catch (e) {
        this.staffOptions = []
      }
    },
    resolveRows(res) {
      if (Array.isArray(res?.data)) return res.data
      if (Array.isArray(res?.records)) return res.records
      if (Array.isArray(res?.list)) return res.list
      if (Array.isArray(res)) return res
      return []
    },
    async onLoad() {
      try {
        const res = await fetchIncomeDetailList(this.buildSearchPayload())
        const list = this.resolveRows(res)
        if (this.refreshing) {
          this.items = []
          this.refreshing = false
        }
        this.items = this.items.concat(list)
        this.finished = list.length < this.pageSize
        if (!this.finished) this.page += 1
      } catch (e) {
        this.finished = true
      } finally {
        this.loading = false
        if (this.scrollToTopAfterLoad) {
          this.scrollToTopAfterLoad = false
          this.$nextTick(() => resetPageScrollAfterPaint(this.$el))
        }
      }
    },
    onRefresh() {
      this.page = 1
      this.finished = false
      this.loading = true
      this.refreshing = true
      this.loadSummary()
      this.onLoad()
    },
    onTypeTabChange(val) {
      this.filters.type = val === "all" ? null : Number(val)
      this.scrollToTopAfterLoad = true
      resetPageScrollAfterPaint(this.$el)
      this.onRefresh()
    },
    clearRange() {
      this.filters.incomeStartDate = ""
      this.filters.incomeEndDate = ""
      this.onRefresh()
    },
    openDateRangePicker() {
      this.dateRangePickerShow = true
    },
    onConfirmDateRange(dates) {
      this.dateRangePickerShow = false
      const arr = Array.isArray(dates) ? dates : [dates]
      const start = arr[0]
      const end = arr[1] || arr[0]
      this.filters.incomeStartDate = start ? formatDateOnly(start) : ""
      this.filters.incomeEndDate = end ? formatDateOnly(end) : ""
      this.onRefresh()
    },
    clearTopDepartmentFilter() {
      this.filters.topDepartmentId = null
      this.onRefresh()
    },
    openTypePicker(target = "form") {
      this.picker.type = "formType"
      this.picker.title = "选择收入类型"
      this.picker.columns = INCOME_TYPE_OPTIONS
      this.picker.show = true
    },
    openOtherFeeTypePicker() {
      this.picker.type = "formOtherFeeType"
      this.picker.title = "选择杂费类型"
      this.picker.columns = OTHER_FEE_TYPE_OPTIONS
      this.picker.show = true
    },
    openPerformanceStaffPicker() {
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.picker.type = "formPerformanceStaff"
      this.picker.title = "选择业绩归属人"
      this.picker.columns = this.staffOptions
      this.picker.show = true
    },
    clearPerformanceStaff() {
      this.formPopup.form.performanceStaffId = null
      this.formPopup.form.performanceStaffName = ""
    },
    openPaymentMethodPicker() {
      this.picker.type = "formPaymentMethod"
      this.picker.title = "选择支付方式"
      this.picker.columns = PAYMENT_METHOD_OPTIONS
      this.picker.show = true
    },
    openTopDepartmentPicker(target = "form") {
      this.picker.type = target === "filter" ? "filterDepartment" : "formDepartment"
      this.picker.title = target === "filter" ? "选择中心" : "选择所属中心"
      const cols = this.topDepartmentOptions
      this.picker.columns = cols
      this.picker.show = true
    },
    openFormTimePicker() {
      const raw = this.formPopup.form.incomeTime
      this.formTimePicker.value = raw ? new Date(String(raw).replace(/-/g, "/")) : new Date()
      this.formTimePicker.show = true
    },
    onPickerConfirm(values, indexes) {
      const value = Array.isArray(values) ? values[0] : values
      const idx = Array.isArray(indexes) ? indexes[0] : indexes
      const col = this.picker.columns[idx]
      if (!col) {
        this.picker.show = false
        return
      }
      if (this.picker.type === "formType") this.formPopup.form.type = col.value
      else if (this.picker.type === "formOtherFeeType") this.formPopup.form.feeType = col.value
      else if (this.picker.type === "formPerformanceStaff") {
        this.formPopup.form.performanceStaffId = col.value
        this.formPopup.form.performanceStaffName = col.text
      }
      else if (this.picker.type === "formPaymentMethod") this.formPopup.form.paymentMethod = col.value
      else if (this.picker.type === "formDepartment") this.formPopup.form.topDepartmentId = col.value
      else if (this.picker.type === "filterDepartment") {
        this.filters.topDepartmentId = col.value
        this.onRefresh()
      }
      this.picker.show = false
    },
    onFormTimeConfirm(value) {
      this.formPopup.form.incomeTime = formatDateTime(value)
      this.formTimePicker.show = false
    },
    async openCreate() {
      this.formPopup.mode = "create"
      this.formPopup.show = true
      await ensureCurrentStaffProfile()
      const defaultDept = getCurrentTopDepartmentId()
      const now = formatDateTime(new Date())
      this.formPopup.form = {
        id: null,
        amount: "",
        type: INCOME_TYPE_MISC,
        typeName: "杂费",
        feeType: null,
        performanceStaffId: null,
        performanceStaffName: "",
        performanceAmount: "",
        studentId: null,
        studentName: "",
        topDepartmentId: defaultDept ?? null,
        incomeTime: now,
        paymentMethod: null,
        remark: ""
      }
    },
    openEdit(row) {
      if (!row) return
      if (this.isIncomeConfirmed(row)) return Toast.fail("收入已确认，无法编辑")
      this.formPopup.mode = "edit"
      this.formPopup.show = true
      const type = this.resolveIncomeType(row.type, row.typeName)
      this.formPopup.form = {
        id: row.id,
        amount: row.amount === null || row.amount === undefined ? "" : String(row.amount),
        type,
        typeName: (row.typeName || "").trim(),
        feeType: this.pickFeeType(row),
        performanceStaffId: row.staffId ?? row.performanceStaffId ?? null,
        performanceStaffName: (row.hostStaffName || row.performanceStaffName || row.staffName || "").trim(),
        performanceAmount:
          row.performanceAmount === null || row.performanceAmount === undefined ? "" : String(row.performanceAmount),
        studentId: row.studentId ?? row.customerId ?? null,
        studentName: (row.studentName || "").trim(),
        topDepartmentId: row.topDepartmentId ?? null,
        incomeTime: row.incomeTime || "",
        paymentMethod: row.paymentMethod ?? null,
        remark: row.remark || ""
      }
    },
    async submitForm() {
      if (this.formPopup.submitting) return
      const form = this.formPopup.form
      const incomeType = this.resolveIncomeType(form.type, form.typeName)
      const payload = {
        amount: Number(form.amount),
        type: incomeType,
        topDepartmentId: Number(form.topDepartmentId),
        incomeTime: form.incomeTime,
        remark: (form.remark || "").trim() || undefined
      }
      if (!Number.isFinite(payload.amount) || payload.amount <= 0) return Toast.fail("请输入正确金额")
      const paymentMethod = this.resolvePaymentMethodValue(form.paymentMethod)
      if (paymentMethod === null) return Toast.fail("请选择支付方式")
      payload.paymentMethod = paymentMethod
      if (!Number.isFinite(payload.type) || payload.type < 0 || payload.type > 6) return Toast.fail("请选择收入类型")
      if (payload.type === INCOME_TYPE_MISC) {
        const feeType = Number(form.feeType)
        if (!Number.isFinite(feeType) || feeType < 1 || feeType > 9) return Toast.fail("请选择杂费类型")
        payload.feeType = feeType
        if (
          form.performanceStaffId !== null &&
          form.performanceStaffId !== undefined &&
          form.performanceStaffId !== ""
        ) {
          payload.staffId = form.performanceStaffId
        }
        const performanceAmount = Number(form.performanceAmount)
        if (form.performanceAmount !== "" && Number.isFinite(performanceAmount)) {
          payload.performanceAmount = performanceAmount
        }
      }
      if (!Number.isFinite(payload.topDepartmentId)) return Toast.fail("请选择所属中心")
      if (!payload.incomeTime) return Toast.fail("请选择收入时间")
      const isOptional = payload.type === INCOME_TYPE_MISC || payload.type === 6
      if (!isOptional && (form.studentId === null || form.studentId === undefined || form.studentId === "")) {
        return Toast.fail("请选择关联学员")
      }
      if (form.studentId !== null && form.studentId !== undefined && form.studentId !== "") {
        payload.studentId = form.studentId
      }

      this.formPopup.submitting = true
      try {
        if (this.formPopup.mode === "create") {
          await createIncomeDetail(payload)
          Toast.success("新增成功")
        } else {
          payload.id = form.id
          await updateIncomeDetail(payload)
          Toast.success("更新成功")
        }
        this.formPopup.show = false
        this.onRefresh()
      } finally {
        this.formPopup.submitting = false
      }
    },
    async onDelete(row) {
      if (!row) return
      if (this.isIncomeConfirmed(row)) return Toast.fail("收入已确认，无法删除")
      const id = row.id
      if (id === null || id === undefined || id === "") return Toast.fail("缺少记录 ID")
      try {
        await Dialog.confirm({ title: "确认删除？", message: "删除后不可恢复" })
      } catch (e) {
        return
      }
      await deleteIncomeDetail(id)
      Toast.success("删除成功")
      this.onRefresh()
    }
  }
}
</script>

<style scoped>
.income-page {
  min-height: 100%;
  background: #f7f8fa;
}

.income-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1200;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.date-filter {
  padding: 0 12px 4px;
  background: #fff;
}

.date-row {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 2px;
}

.date-label {
  font-size: 13px;
  color: #969799;
  flex-shrink: 0;
}

.date-value {
  color: #323233;
  font-size: 13px;
  padding: 1px 5px;
  border-radius: 6px;
  background: #f7f8fa;
}

.date-value--wide {
  flex: 0 0 auto;
  display: inline-block;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date-sep {
  color: #969799;
}

.date-clear {
  margin-left: 6px;
  font-size: 12px;
  color: rgb(242, 124, 52);
  flex: 0 0 auto;
}

.income-type-tabs {
  padding: 0 8px;
}

.income-summary-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 16px 6px;
  border-bottom: 1px solid #f2f3f5;
  background: #fff;
}

.income-summary-item {
  font-size: 13px;
  color: #646566;
  line-height: 1.4;
}

.income-summary-amount {
  margin-left: 4px;
  font-size: 16px;
  font-weight: 700;
  color: rgb(242, 124, 52);
}

.income-summary-count {
  margin-left: 4px;
  font-size: 16px;
  font-weight: 700;
  color: #323233;
}

.income-list {
  /* fixed top: 2 filter rows + tabs + summary */
  padding: 132px 12px calc(88px + var(--app-tabbar-offset, 52px));
  background: #f7f8fa;
  min-height: 100vh;
}

.records-wrap {
  padding-bottom: 10px;
  background: transparent;
}

.empty {
  padding: 26px 0;
}

.income-booking-card {
  --accent-color: rgba(150, 151, 153, 0.6);
  --accent-wash: rgba(150, 151, 153, 0.1);
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  padding: 14px 14px 12px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f2f3f5;
  margin-bottom: 10px;
}

.income-booking-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  background: linear-gradient(90deg, var(--accent-wash) 0%, rgba(255, 255, 255, 0) 100%);
}

.income-booking-card::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 9px;
  bottom: 9px;
  width: 4px;
  border-radius: 999px;
  background: var(--accent-color);
}

.income-type-0 {
  --accent-color: rgba(242, 124, 52, 0.72);
  --accent-wash: rgba(242, 124, 52, 0.12);
}
.income-type-1 {
  --accent-color: rgba(74, 178, 194, 0.72);
  --accent-wash: rgba(74, 178, 194, 0.12);
}
.income-type-2 {
  --accent-color: rgba(111, 127, 242, 0.72);
  --accent-wash: rgba(111, 127, 242, 0.12);
}
.income-type-3 {
  --accent-color: rgba(146, 186, 63, 0.76);
  --accent-wash: rgba(146, 186, 63, 0.12);
}
.income-type-4 {
  --accent-color: rgba(214, 93, 140, 0.72);
  --accent-wash: rgba(214, 93, 140, 0.12);
}
.income-type-5 {
  --accent-color: rgba(245, 158, 11, 0.72);
  --accent-wash: rgba(245, 158, 11, 0.12);
}
.income-type-6 {
  --accent-color: rgba(107, 114, 128, 0.65);
  --accent-wash: rgba(107, 114, 128, 0.12);
}

.income-type-default {
  --accent-color: rgba(150, 151, 153, 0.6);
  --accent-wash: rgba(150, 151, 153, 0.1);
}

.income-booking-card .booking-student-name {
  font-size: 16px;
  font-weight: 700;
}

.booking-card-top {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.booking-student {
  margin-top: -10px;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.income-status-tag {
  flex-shrink: 0;
  padding: 0 8px;
  font-size: 11px;
  line-height: 18px;
  border-radius: 4px;
}

.income-status-tag--confirmed {
  color: #07c160;
  background: rgba(7, 193, 96, 0.12);
  border: 1px solid rgba(7, 193, 96, 0.35);
}

.income-booking-card--confirmed {
  border-color: rgba(7, 193, 96, 0.22);
  background: linear-gradient(180deg, rgba(7, 193, 96, 0.04) 0%, #fff 48px);
}

.booking-parent {
  font-size: 13px;
  color: #646566;
  line-height: 1.5;
  margin-top: 2px;
}

.booking-parent-label {
  color: #646566;
}

.booking-remark {
  margin-top: 3px;
  font-size: 13px;
  color: #646566;
  line-height: 1.5;
}

.income-amount {
  color: rgb(242, 124, 52);
  font-weight: 700;
  font-size: 24px;
  line-height: 1;
  position: absolute;
  top: 14px;
  right: 14px;
  white-space: nowrap;
}

.income-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.income-op-btn {
  flex: 1;
  min-width: 60px;
  height: 26px;
  line-height: 24px;
  font-size: 12px;
}

.income-op-btn--edit {
  color: #f27c34;
  border-color: rgba(242, 124, 52, 0.45);
  background: rgba(242, 124, 52, 0.08);
}

.income-op-btn--delete {
  color: #d65d8c;
  border-color: rgba(214, 93, 140, 0.45);
  background: rgba(214, 93, 140, 0.08);
}

.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--app-tabbar-offset, 50px);
  padding: 10px 12px;
  background: #fff;
  box-shadow: 0 -6px 16px rgba(0, 0, 0, 0.06);
  z-index: 1000;
}

.bottom-bar :deep(.van-button--primary) {
  background: var(--mg-orange, rgb(242, 124, 52));
  border-color: var(--mg-orange, rgb(242, 124, 52));
}

.field-clear-btn {
  font-size: 12px;
  color: rgb(242, 124, 52);
  padding: 0 4px;
}

.student-picker-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.student-list-wrap {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 12px 8px;
}

.student-item {
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(30, 35, 90, 0.05);
  margin-bottom: 8px;
}

.student-item.active {
  background: rgba(242, 124, 52, 0.12);
  border: 1px solid rgba(242, 124, 52, 0.35);
}

.student-item-name {
  font-size: 14px;
  font-weight: 700;
  color: #323233;
}

.student-item-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}


:deep(.van-tab--active) {
  color: var(--mg-orange, rgb(242, 124, 52));
}

:deep(.van-tabs__line) {
  background: var(--mg-orange, rgb(242, 124, 52));
}

:deep(.van-tabs__wrap) {
  height: 34px;
}

.income-list :deep(.van-pull-refresh),
.income-list :deep(.van-pull-refresh__track),
.income-list :deep(.van-list) {
  background: transparent;
}

.popup-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.popup-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #ebedf0;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
}

.popup-close {
  font-size: 18px;
  color: #969799;
}

.popup-body {
  flex: 1;
  overflow-y: auto;
}

.income-kv {
  font-size: 13px;
  color: #646566;
  line-height: 1.6;
  padding: 2px 0;
}

.popup-actions {
  padding: 10px 16px calc(10px + var(--app-safe-area-bottom, 0px));
  border-top: 1px solid #ebedf0;
}

.popup-actions .theme-btn {
  border: none !important;
  background: rgb(242, 124, 52) !important;
  color: #fff !important;
}

</style>
